export default function FourZeroFourTemplate({ page, renderSections }) {
  return <div data-comp="FourZeroFourTemplate">{renderSections()}</div>;
}
